/**
 * Flatlogic Dashboards (https://flatlogic.com/admin-dashboards)
 *
 * Copyright © 2015-present Flatlogic, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import { connect } from "react-redux";
import cx from "classnames";
import React from "react";
import PropTypes from "prop-types";
import {
  Navbar,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link } from "react-router-dom";

import photo from "../../images/avatar/user.svg";
import { logoutUser } from "../../actions/user";
import s from "./Header.module.scss";
import jwt from "jsonwebtoken";
import { USER_ROLE } from "../../constants";

class Header extends React.Component {
  static propTypes = {
    sidebarToggle: PropTypes.func,
    dispatch: PropTypes.func.isRequired,
  };

  static defaultProps = {
    sidebarToggle: () => {},
  };

  state = {
    isOpen: false,
    currUser: {},
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  doLogout = () => {
    this.props.dispatch(logoutUser());
  };

  componentDidMount() {
    let token = localStorage.getItem("id_token");
    this.setState({ currUser: jwt.decode(token) });
  }

  render() {
    const { isOpen } = this.state;
    return (
      <Navbar className={`${isOpen?'nav-open': ' '} ${s.root}`}>
       <Nav className={s.headerLeft}></Nav>
        <Nav className={s.userLogin}>
    
          <NavItem>
            <Dropdown isOpen={isOpen} toggle={this.toggleDropdown}>
              <DropdownToggle nav>
                <img
                  className={cx("rounded-circle mr-sm", s.adminPhoto)}
                  src={photo}
                  alt="administrator"
                />
                <span>
                  {this.state.currUser.displayName}
                </span>
                <img
                  alt=""
                  className={cx("fa fa-anglaae-down ml-sm", s.arrow, {
                    [s.arrowActive]: isOpen,
                  })}
                />
              </DropdownToggle>
              <DropdownMenu style={{ width: "100%" }}>
                {this.state.currUser.role !== USER_ROLE.ADMIN ? (
                  <DropdownItem>
                    <Link header="Hồ sơ" to="/app/profile">
                      {" "}
                      Hồ sơ{" "}
                    </Link>{" "}
                  </DropdownItem>
                ) : (
                  ""
                )}
                <DropdownItem href="/" onClick={this.doLogout}>
                  {" "}
                  Đăng xuất{" "}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </NavItem>
        </Nav>
      </Navbar>
    );
  }
}
function mapStateToProps(state) {
  return {
    init: state.runtime.initialNow,
  };
}

export default connect(mapStateToProps)(Header);
